(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-categorias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function update(track) {
      var wrap = track.closest('[data-pm-cat]');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-pm-cat-prev]');
      var next = wrap.querySelector('[data-pm-cat-next]');
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    function initAll() {
      document.querySelectorAll('[data-pm-cat-track]').forEach(update);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pm-cat-prev], [data-pm-cat-next]');
      if (!btn) return;
      var wrap = btn.closest('[data-pm-cat]');
      var track = wrap && wrap.querySelector('[data-pm-cat-track]');
      if (!track) return;
      var dir = btn.hasAttribute('data-pm-cat-next') ? 1 : -1;
      var item = track.querySelector('.pm-cat__item');
      var step = item ? item.getBoundingClientRect().width * 2 : track.clientWidth * 0.8;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
    });

    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-pm-cat-track]')) {
        update(e.target);
      }
    }, true);

    window.addEventListener('resize', initAll);
    window.addEventListener('load', initAll);
    document.addEventListener('shopify:section:load', initAll);
    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
